import Asset from './asset';

export default class Portfolio {
  constructor(data) {
    this.assets = [];

    if (!data) {
      return;
    }

    this.taxFlag = data.taxflag || 'taxable';

    // there will be a label for each item (we just need the index)
    data?.labels?.forEach((label, index) => {
      let taxStatus = 'taxable';

      if (data.datasets && data.datasets.length > 0 && data.datasets[0].data_taxable) {
        if (Number.parseFloat(data.datasets[0].data_taxable[index]) === 0) {
          taxStatus = 'advantaged';
        } else if (Number.parseFloat(data.datasets[0].data_taxadvantaged[index]) === 0) {
          taxStatus = 'taxable';
        } else {
          taxStatus = 'both';
        }
      }

      this.assets.push(
        new Asset({
          tickerData: data.tickers[index],
          color: data.datasets[0].backgroundColor[index],
          percentage: data.datasets[0].data[index],
          taxAdvantagedPercentage: data.datasets[0].data_taxadvantaged
            ? data.datasets[0].data_taxadvantaged[index]
            : '0.00',
          taxablePercentage: data.datasets[0].data_taxable
            ? data.datasets[0].data_taxable[index]
            : data.datasets[0].data[index],
          label: data.labels[index],
          taxStatus,
          taxFlag: this.taxFlag,
        })
      );
    });
  }

  hasMixedTaxStatus() {
    return this.taxFlag === 'both';
  }

  hasData() {
    return this.assets && this.assets.length > 0;
  }
}
